module.exports = __webpack_public_path__ + "img/BAU Seniors_23.f3fc99db.jpg";